import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDlcList, useDlcTypeDrop } from 'apis/story/dlcApis';
import TableToolbar from 'components/table/TableToolbar';
import DefaultButton from 'components/button/DefaultButton';
import MainTable from 'components/table/MainTable';
import TextButton from 'components/button/TextButton';
import CapsuleButton from 'components/button/CapsuleButton';
import DLCRegisterModal from './DLCRegisterModal';
import DLCEpisodeTable from './episode/DLCEpisodeTable';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

interface IProps {
  projectType?: string | 'otome';
  selectProject?: any;
  draggingStatus?: any;
  setDraggingStatus?: any;
  dlcMainStatus: boolean;
  setDlcMainStatus: (e) => void;
}
export interface IEpisodeProps {
  episodeClick: boolean;
  dlcId?: number;
}
const DLCMainTable = ({
  dlcMainStatus,
  setDlcMainStatus,
  selectProject,
  draggingStatus,
  setDraggingStatus,
}: IProps) => {
  const { t } = useTranslation();
  const { projectId, dlcId } = useParams();
  const [cookies, setCookie] = useCookies();
  const navigate = useNavigate();

  const [visible, setVisible] = useState<boolean>(false);
  const [episodeClick, setEpisodeClick] = useState<boolean>(false);

  const { data: dlcTypeDropList } = useDlcTypeDrop();
  const { data: dlcListData } = useDlcList(projectId);

  const handleDetailClick = (record) => () => {
    navigate(`${record.dlc_id}`, {
      state: { tabKey: 'dlc', record: record },
    });
    setEpisodeClick(true);
    setCookie('dlcId', record.dlc_id);
  };
  const handleUpdateClick = (record) => () => {
    navigate(`${record.dlc_id}/update`, {
      state: { record: record },
    });
  };
  const handleOpen = () => {
    setVisible(true);
  };

  const columnsOrigin = [
    {
      title: 'DLC ID',
      dataIndex: 'dlc_id',
      // width: '6rem',
      // align: 'center',
      // sorter: (a, b) => a.episode_id - b.episode_id,
    },
    {
      title: (
        <p>{t('storyEpisodeID.storyTabMenuList.DLCContent.table.dlcName')}</p>
      ),
      dataIndex: 'dlc_name',
      // width: '6rem',
      // align: 'center',
      // sorter: (a, b) => a.episode_id - b.episode_id,
      render: (text, record) => (
        <TextButton onClick={handleDetailClick(record)}>{text}</TextButton>
      ),
    },
    {
      title: (
        <p>{t('storyEpisodeID.storyTabMenuList.DLCContent.table.dlcType')}</p>
      ),
      dataIndex: 'dlc_type',
      filters: dlcTypeDropList,
      onFilter: (value, record) => record?.dlc_type === value,
      render: (text) =>
        dlcTypeDropList?.map((v) => v.value === text && <p>{v.text}</p>),
      // width: '6rem',
      // align: 'center',
    },
    {
      title: (
        <p>{t('storyEpisodeID.storyTabMenuList.DLCContent.table.price')}</p>
      ),
      dataIndex: 'price',
      // width: '6rem',
      // align: 'center',
      // sorter: (a, b) => a.episode_id - b.episode_id,
    },
    {
      title: (
        <p>{t('storyEpisodeID.storyTabMenuList.DLCContent.table.salePrice')}</p>
      ),
      dataIndex: 'sale_price',
      // width: '6rem',
      // align: 'center',
      // sorter: (a, b) => a.episode_id - b.episode_id,
    },
    {
      title: (
        <p>{t('storyEpisodeID.storyTabMenuList.DLCContent.table.action')}</p>
      ),
      // width: '6rem',
      align: 'center',
      render: (text, record) => (
        <CapsuleButton onClick={handleUpdateClick(record)}>
          {t('storyEpisodeID.storyTabMenuList.DLCContent.table.correction')}
        </CapsuleButton>
      ),
    },
  ];
  useEffect(() => {
    if (dlcId) {
      setEpisodeClick(true);
    }
  }, []);

  return (
    <>
      {episodeClick ? (
        <DLCEpisodeTable
          dlcMainStatus={dlcMainStatus}
          setDlcMainStatus={setDlcMainStatus}
          selectProject={selectProject}
          episodeClick={episodeClick}
          setEpisodeClick={setEpisodeClick}
          draggingStatus={draggingStatus}
          setDraggingStatus={setDraggingStatus}
        />
      ) : (
        <>
          <TableToolbar>
            {/* <InputSearch
              placeholder="에피소드 제목을 검색하세요"
              setSearchData={setSearchData}
            /> */}
            <div></div>
            <DefaultButton
              name='register'
              onClick={handleOpen}
              // disabled={selectProject?.auth}
            >
              {t('storyEpisodeID.storyTabMenuList.DLCContent.header.createDLC')}
            </DefaultButton>
          </TableToolbar>
          <MainTable
            columns={columnsOrigin}
            dataSource={dlcListData}
            //   searchData
            //     ? dlcListData?.filter(
            //         data => data.title.indexOf(searchData) !== -1,
            //       )
            //     : dlcListData
            // }
          />
          <DLCRegisterModal
            projectId={projectId!}
            visible={visible}
            setVisible={setVisible}
          />
        </>
      )}
    </>
  );
};

export default DLCMainTable;
